import React, {ReactElement} from "react";

import {SimpleFormProps} from "/src/types";
import {
  getChildFields,
  getFormFieldConditions,
} from "./conditional-field-registry";
import SimpleForm from "../../simple-form/SimpleForm";

import CapitalInquiryRequestForm from "./CapitalInquiryRequestForm";
import InsuranceForm from "./InsuranceForm";
import InsuranceMultiStepForm from "./InsuranceMultiStepForm";
import MainSignUpContactUs from "./MainSignUpContactUs";
import OverhaulSignUpStep2Form from "./OverhaulSignUpStep2Form";
import SMBCustomsBondForm from "./SMBCustomsBondForm";
import SMBRiskManagementForm from "./SMBRiskManagementForm";
import WarehouseTourForm from "./WarehouseTourForm";

const FORM_NAME = {
  RISK_MANAGEMENT: "payment-method-and-risk-management",
  CUSTOMS_BOND: "customs-bond",
  CAPITAL_INQUIRY_REQUEST_FORM: "capital-inquiry-request-form",
  INSURANCE: "insurance",
  INSURANCE_MULTI_STEPS: "insurance-2",
  OVERHAUL_SIGN_UP_STEP_2: "overhaul-sign-up-form-step-2",
  // TODO: (jwenlihuang) Form name will likely change after testing per Aja, in follow up PR
  SIGN_UP: "sign-up",
  WAREHOUSE_TOUR: "warehouse-tour",
};

const fetchConditionalForm = (
  formName: string,
  props: SimpleFormProps
): ReactElement<any> => {
  const childFields = getChildFields(formName || "");
  const conditionFields = getFormFieldConditions(formName || "");

  /*
    Register Conditional Form Component
  */
  switch (formName) {
    case FORM_NAME.RISK_MANAGEMENT:
      return (
        <SMBRiskManagementForm
          {...props}
          conditionFields={conditionFields}
          childFields={childFields}
        />
      );
    case FORM_NAME.CUSTOMS_BOND:
      return (
        <SMBCustomsBondForm
          {...props}
          conditionFields={conditionFields}
          childFields={childFields}
        />
      );
    case FORM_NAME.CAPITAL_INQUIRY_REQUEST_FORM:
      return (
        <CapitalInquiryRequestForm
          {...props}
          conditionFields={conditionFields}
          childFields={childFields}
        />
      );
    case FORM_NAME.SIGN_UP:
      return (
        <MainSignUpContactUs
          {...props}
          conditionFields={conditionFields}
          childFields={childFields}
        />
      );
    case FORM_NAME.INSURANCE:
      return (
        <InsuranceForm
          {...props}
          conditionFields={conditionFields}
          childFields={childFields}
        />
      );
    case FORM_NAME.INSURANCE_MULTI_STEPS:
      return (
        <InsuranceMultiStepForm
          {...props}
          conditionFields={conditionFields}
          childFields={childFields}
        />
      );
    case FORM_NAME.OVERHAUL_SIGN_UP_STEP_2:
      return (
        <OverhaulSignUpStep2Form
          {...props}
          conditionFields={conditionFields}
          childFields={childFields}
        />
      );
    case FORM_NAME.WAREHOUSE_TOUR:
      return (
        <WarehouseTourForm
          {...props}
          conditionFields={conditionFields}
          childFields={childFields}
        />
      );
    default:
      return <SimpleForm {...props} />;
  }
};

export default fetchConditionalForm;
